// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CircleX = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M43.757 48 30.322 61.435l4.243 4.243L48 52.243l13.435 13.435 4.243-4.243L52.243 48l13.435-13.435-4.243-4.243L48 43.757 34.565 30.322l-4.243 4.243L43.757 48ZM48 87.5C26.185 87.5 8.5 69.815 8.5 48S26.185 8.5 48 8.5 87.5 26.185 87.5 48 69.815 87.5 48 87.5Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default CircleX;
